<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div  
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
  
 <login-form  title="" v-on:submit="login" :path="path" />
    
  </div>
</template>

<script>
import Login from '../../../components/auth/Login'
export default {
    components:{
        'login-form' : Login
    },
  data() {
    return {
      email: "",
      password: "",
      checkbox_remember_me: false,
      loginForm: {},
      path:"",
         show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,
    };
  },
   created() {
    this.path="/user/forgot-password";
  },
  methods: {
    /**
     * Login API call
     * @author Madhura shah
     */
    login(val){
        if(val != ''){
     this.show = true;
      this.success = "";
      this.error = "";
             // call store function
            this.$store
            .dispatch("UserLogin", val)
                .then(() => {
               this.show=false;
                
              this.success = this.$t("WelcomeToDashboard");
              this.$toasted.show(this.success, {
                className: "top-alert",
                position: "top-center",
                type: "success",
                duration: 2000,
              });
                this.$router.push({ path: '/' });
            })
            .catch(error => {
                this.$log.error('File : UserLogin.vue | Function : handleLogin() | Error :', error);
                   this.show=true;
              this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
                return false;
            });
        }
        
    }
  }
};
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>
